import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BannerImg from "../../../images/locationgcc/dxb/Experienced.webp";

function whychoose(props) {
  return (
    <div
      className="whychoose why_choosedubai p-100"
      style={{ backgroundImage: `url(${BannerImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={5}>
            <h2>Following agile principles for your <span>Business Success</span></h2>
            <p>
            Building custom solutions by translating the client’s needs into fully-functional products is the key! Our software development company UAE understands that designing, building, deploying, and maintaining software cater to your designated users, companies, and functions.
            </p>
            <p>
            Our results-driven and number-focused outcomes fuel us to build systems that have an actual impact on the users and add value to their lives. As a leading software development company, TekRevol helps you multiply your growth by:
            </p>
            <ul>
              <li>Helping You Find Inefficiencies In Your Process</li>
              <li>Reaching And Acquiring New Customers</li>
              <li>Retaining Customers By Offering Value Bundles</li>
              <li>Improving Customer Engagement Rates</li>
              <li>Opening New Revenue Streams And Directing Energies</li>
              <li>Focusing On Transferring The Impact To The Users</li>
            </ul>
            <p>We do more than that – tell us what works for you, and our digital experts will be in line to provide you with the ideal digital solution – custom-made for you.</p>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="choose-main">
              <div className="choose-box">
                <div className="choose-num">
                  300+<span>Apps Developed</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  65+<span>Review</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  35+<span>Industries Served</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default whychoose;
